/**
 * Module Studio (UPT-2079 lot L2, §4.3) — normalisation et mesures du contenu
 * Markdown d'une spec, identiques à `SpecContent` du serveur (rest §4.4.1) :
 * BOM U+FEFF initial retiré, CRLF et CR → LF, aucune autre transformation
 * (espaces de fin et ligne finale conservés). Fonctions pures.
 */
import { DESIGN_LIMITS } from '../data/contracts';

const BOM = '﻿';

/** Contenu normalisé (null ou undefined → chaîne vide). */
export const normalizeSpecContent = (text: string | null | undefined): string => {
  let value = text ?? '';
  if (value.startsWith(BOM)) {
    value = value.slice(1);
  }
  return value.replace(/\r\n?/g, '\n');
};

/** Nombre d'octets UTF-8 d'un texte (paires de substituts comptées sur 4 octets). */
export const utf8Bytes = (text: string): number => {
  let bytes = 0;
  for (let index = 0; index < text.length; index += 1) {
    const code = text.charCodeAt(index);
    if (code < 0x80) {
      bytes += 1;
    } else if (code < 0x800) {
      bytes += 2;
    } else if (code >= 0xd800 && code <= 0xdbff && index + 1 < text.length) {
      const next = text.charCodeAt(index + 1);
      if (next >= 0xdc00 && next <= 0xdfff) {
        bytes += 4;
        index += 1;
      } else {
        bytes += 3;
      }
    } else {
      bytes += 3;
    }
  }
  return bytes;
};

/** Lignes d'un contenu au sens du diff (rest §4.5) : vide → aucune ; sinon privé d'un LF final puis découpé sur LF. */
export const contentLines = (text: string): string[] => {
  const normalized = normalizeSpecContent(text);
  if (normalized === '') {
    return [];
  }
  const body = normalized.endsWith('\n') ? normalized.slice(0, -1) : normalized;
  return body.split('\n');
};

/** Nombre de lignes au sens du diff : vide = 0, « a » = 1, « a\n » = 1, « a\n\n » = 2. */
export const lineCount = (text: string): number => contentLines(text).length;

/** Vrai quand le contenu normalisé dépasse la borne du contrat (413 spec.too_large). */
export const isSpecContentTooLarge = (normalized: string): boolean =>
  utf8Bytes(normalized) > DESIGN_LIMITS.specContentMaxBytes;
